var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button is-white has-text-dark",class:[_vm.buttonClass],attrs:{"role":"button"},on:{"click":_vm.clicked}},[_c('b-icon',{attrs:{"icon":_vm.icon,"size":"is-small"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }